import {
  every, first, get, isEqual, max,
} from 'lodash';
import { TipoFrete } from 'px-business-components';

function hasMoreThanOneItem(carrinhos) {
  return carrinhos && carrinhos.length > 1;
}

function isEqualField(carrinhos, field) {
  const respostas = carrinhos.map(carrinho => carrinho.respostaCotacao);
  const diff = respostas.reduce((a, b) => ((isEqual(get(a, field), get(b, field))) ? a : false));
  return Boolean(diff);
}

function allItensCotacao(carrinho) {
  return carrinho.quantidadeProdutos === carrinho.respostaCotacao.quantidadeProdutos;
}

function allItensCotacaoCarrinhos(carrinhos) {
  return every(carrinhos, allItensCotacao);
}

function allFreteGratis(carrinhos) {
  return every(carrinhos, car => car.respostaCotacao.frete.ofertaFreteGratis);
}

function isFreteCif(carrinho) {
  return carrinho.respostaCotacao.frete.tipoFrete === TipoFrete.keys.CIF.key;
}

function solicitaFormaPagamento(carrinhos) {
  if (hasMoreThanOneItem(carrinhos)) {
    if (isEqualField(carrinhos, 'formaPagamento')
      && isEqualField(carrinhos, 'prazoPagamento')
      && allItensCotacaoCarrinhos(carrinhos)) {
      return {
        formaPagamento: first(carrinhos).respostaCotacao.formaPagamento,
        prazoPagamento: first(carrinhos).respostaCotacao.prazoPagamento,
        solicitaFormaPagamento: false,
      };
    }
    return {
      formaPagamento: first(carrinhos).respostaCotacao.formaPagamento,
      prazoPagamento: first(carrinhos).respostaCotacao.prazoPagamento,
      solicitaFormaPagamento: true,
    };
  }
  if (allItensCotacao(first(carrinhos))) {
    return {
      formaPagamento: first(carrinhos).respostaCotacao.formaPagamento,
      prazoPagamento: first(carrinhos).respostaCotacao.prazoPagamento,
      solicitaFormaPagamento: false,
    };
  }
  return {
    formaPagamento: first(carrinhos).respostaCotacao.formaPagamento,
    prazoPagamento: first(carrinhos).respostaCotacao.prazoPagamento,
    solicitaFormaPagamento: true,
  };
}

function getObservacaoFrete(carrinhos) {
  const observacoes = carrinhos.map(carrinho => carrinho.respostaCotacao.frete.observacaoFrete)
    .filter(obs => obs);
  return observacoes.join('|\n');
}

function getTipoFrete(carrinhos) {
  const allCif = every(carrinhos, isFreteCif);
  if (allCif) {
    return TipoFrete.keys.CIF.key;
  }
  return TipoFrete.keys.FOB.key;
}

function getValorFrete(carrinhos) {
  return max(carrinhos.map(c => c.respostaCotacao.frete.totalTransporte));
}

function getValorFreteConvertido(carrinhos) {
  return max(carrinhos.map(c => c.respostaCotacao.frete.totalTransporteConvertido));
}

function getPrazoEntrega(carrinhos) {
  const prazos = carrinhos.map(carrinho => carrinho.respostaCotacao.frete.prazoEntrega);
  return max(prazos);
}

function getValorFreteGratis(carrinhos) {
  if (!allFreteGratis(carrinhos)) {
    return {
      oferta: false,
      valor: 0,
    };
  }
  const valores = carrinhos.map(carrinho => carrinho.respostaCotacao.frete.valorMinimoFreteGratis);
  return {
    oferta: true,
    valor: max(valores),
  };
}

export {
  hasMoreThanOneItem,
  isEqualField,
  allItensCotacao,
  allItensCotacaoCarrinhos,
  solicitaFormaPagamento,
  getObservacaoFrete,
  getValorFrete,
  getPrazoEntrega,
  getValorFreteGratis,
  getTipoFrete,
  getValorFreteConvertido,
};
